export default __webpack_public_path__ + "static/media/popupRed.1add5205.png";